import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Pause = forwardRef<SVGSVGElement | null, IconFilledProps>(function Pause({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M10.75 7.55021C10.75 7.27407 10.5261 7.05021 10.25 7.05021L9.75 7.05021C9.47386 7.05021 9.25 7.27407 9.25 7.55021L9.25 16.4497C9.25 16.7258 9.47386 16.9497 9.75 16.9497H10.25C10.5261 16.9497 10.75 16.7259 10.75 16.4497V7.55021Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M14.25 7.05021C14.5261 7.05021 14.75 7.27407 14.75 7.55021V16.4497C14.75 16.7259 14.5261 16.9497 14.25 16.9497H13.75C13.4739 16.9497 13.25 16.7258 13.25 16.4497V7.55021C13.25 7.27407 13.4739 7.05021 13.75 7.05021L14.25 7.05021Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.0711 4.92893C22.9763 8.83417 22.9763 15.1658 19.0711 19.0711C15.1658 22.9763 8.83418 22.9763 4.92893 19.0711C1.02369 15.1658 1.02369 8.83418 4.92893 4.92893C8.83417 1.02369 15.1658 1.02369 19.0711 4.92893ZM18.0104 5.98959C21.3299 9.30905 21.3299 14.691 18.0104 18.0104C14.691 21.3299 9.30905 21.3299 5.98959 18.0104C2.67014 14.691 2.67014 9.30905 5.98959 5.98959C9.30905 2.67014 14.691 2.67014 18.0104 5.98959Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.92893 19.0711C8.83417 22.9763 15.1658 22.9763 19.0711 19.0711C22.9763 15.1658 22.9763 8.83418 19.0711 4.92893C15.1658 1.02369 8.83418 1.02369 4.92893 4.92893C1.02369 8.83418 1.02369 15.1658 4.92893 19.0711ZM10.75 7.55029C10.75 7.27415 10.5261 7.05029 10.25 7.05029H9.75C9.47386 7.05029 9.25 7.27415 9.25 7.55029V16.4498C9.25 16.7259 9.47386 16.9498 9.75 16.9498H10.25C10.5261 16.9498 10.75 16.7259 10.75 16.4498V7.55029ZM14.75 7.55029C14.75 7.27415 14.5261 7.05029 14.25 7.05029H13.75C13.4739 7.05029 13.25 7.27415 13.25 7.55029V16.4498C13.25 16.7259 13.4739 16.9498 13.75 16.9498H14.25C14.5261 16.9498 14.75 16.7259 14.75 16.4498V7.55029Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'pause-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Pause;
